declare global {
  interface Window {
    umami?: { track(event: string, data?: Record<string, string | number | boolean>): void }
  }
}

export function initUmami() {
  const scriptUrl = import.meta.env.VITE_UMAMI_SCRIPT_URL
  const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID
  if (!scriptUrl || !websiteId) return

  const script = document.createElement('script')
  script.defer = true
  script.src = scriptUrl
  script.setAttribute('data-website-id', websiteId)
  document.head.appendChild(script)
}

export function trackEvent(name: string, data?: Record<string, string | number | boolean>) {
  window.umami?.track(name, data)
}
